import { AUTH_AI_ASSISTANT } from "domain/authority";
import { hasAiAssistantLicenseBundle } from "services/tenants/tenantCookieService";
import { userSessionService } from "services/user/UserSessionService";

export function useIsAiHomeEnabled(): boolean {
    return hasAiAssistantLicenseBundle() && userSessionService.userHasAnyAuthority([AUTH_AI_ASSISTANT]);
}
